import { Icon } from '@/components/ui/Icon'
import { Loader } from '@/components/ui/Loader'
import { resolveImageUrl } from '@/lib/image-url'
import { useRouteStore } from '@/store/route'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styles from './Items.module.scss'

export const ItemsPage = () => {
  const navigate = useNavigate()
  const { stop } = useParams<{ stop: string }>()

  const currentDonation = useRouteStore((state) => state.currentDonation)
  const currentDonationLoading = useRouteStore(
    (state) => state.currentDonationLoading
  )
  const fetchDonation = useRouteStore((state) => state.fetchDonation)

  const stopId = Number(stop)
  const isLoading =
    currentDonationLoading ||
    (currentDonation !== null && currentDonation.id !== stopId)

  useEffect(() => {
    if (stop && (!currentDonation || currentDonation.id !== stopId)) {
      fetchDonation(stopId)
    }
  }, [stop, stopId, currentDonation, fetchDonation])

  const items = (currentDonation?.items ?? []).filter((item) => item.photo_url)

  const handleBack = () => {
    navigate(-1)
  }

  if (isLoading || !currentDonation) {
    const title = isLoading ? 'Donation Items' : 'Donation not found'
    return (
      <div className={styles.container} data-testid="items-page-loading">
        <div className={styles.content}>
          <header className={styles.header}>
            <button
              className={styles.backButton}
              onClick={handleBack}
              data-testid="items-back-button"
            >
              <Icon name="chevron-left" size={20} className={styles.backIcon} />
            </button>
            <h1 className={styles.title}>{title}</h1>
          </header>
          {isLoading && <Loader testId="items-loader" />}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container} data-testid="items-page">
      <div className={styles.content}>
        {/* Header */}
        <header className={styles.header}>
          <button
            className={styles.backButton}
            onClick={handleBack}
            data-testid="items-back-button"
          >
            <Icon name="chevron-left" size={20} className={styles.backIcon} />
          </button>
          <h1 className={styles.title}>Donation Items</h1>
        </header>

        {/* Items List */}
        <div className={styles.itemsList} data-testid="items-list">
          {items.length === 0 ? (
            <p className={styles.emptyText} data-testid="items-empty">
              No items
            </p>
          ) : (
            items.map((item) => (
              <div
                key={item.id}
                className={styles.itemCard}
                data-testid={`item-card-${item.id}`}
              >
                {item.photo_url ? (
                  <img
                    src={resolveImageUrl(item.photo_url)}
                    alt={item.name}
                    className={styles.itemImage}
                  />
                ) : item.icon_url ? (
                  <div className={styles.itemIconWrapper}>
                    <img
                      src={resolveImageUrl(item.icon_url)}
                      alt={item.name}
                      className={styles.itemIcon}
                    />
                  </div>
                ) : (
                  <div className={styles.itemPlaceholder}>
                    <Icon
                      name="job"
                      size={48}
                      className={styles.placeholderIcon}
                    />
                  </div>
                )}
                <h2 className={styles.itemName}>{item.name}</h2>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
